import { render, staticRenderFns } from "./SmsSetupCompleteModal.vue?vue&type=template&id=ad144b36&scoped=true"
import script from "./SmsSetupCompleteModal.vue?vue&type=script&lang=js"
export * from "./SmsSetupCompleteModal.vue?vue&type=script&lang=js"
import style0 from "./SmsSetupCompleteModal.vue?vue&type=style&index=0&id=ad144b36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad144b36",
  null
  
)

export default component.exports